import { errorToast } from "@/v2-ui/toast"
import Manage from "@/v2-backoffice-client/components/manage"
import { ConfirmButton } from "@/v2-backoffice-client/components/button"
import { formatUserName } from "@/v2-backoffice-client/user/user.utils"
import { useTenantUserRemoveMutation } from "@/v2-backoffice-client/tenant/user/remove/tenant.user.remove.mutation"
import type { UserTenantFragment } from "@/v2-backoffice-client/user/tenant/__types__/user.tenant.fragment"
import TenantUserTypePicker from "@/v2-backoffice-client/tenant/user/type/TenantUserTypePicker"

export type TenantUserManageMemberItemProps = {
  userTenant: UserTenantFragment
  tenantId: number
  onRemoved(): void
}

function TenantUserManageMemberItem(props: TenantUserManageMemberItemProps) {
  const { userTenant, tenantId, onRemoved } = props

  const [remove, { error, loading }] = useTenantUserRemoveMutation()
  errorToast(error, { title: "Failed to remove user from team" })

  function handleRemove() {
    remove({ variables: { tenantId, userId: userTenant.UserId } })
    onRemoved()
  }

  const user = userTenant.User
  const isRemoved = user?.UserStatus.Name === "Removed"

  return (
    <Manage.Item>
      <Manage.Item.Text
        primary={formatUserName(user?.FirstName, user?.LastName)}
        secondary={user?.Email ?? undefined}
        tag={isRemoved ? "removed" : undefined}
      />
      <TenantUserTypePicker size="xs" userTenant={userTenant} />
      <ConfirmButton
        isLoading={loading}
        size="xs"
        variant="destructive"
        isSquare
        iconSrc="trash"
        content="Remove user from team"
        confirmContent="Remove?"
        confirmVariant="destructive"
        onConfirm={handleRemove}
      />
    </Manage.Item>
  )
}

export default TenantUserManageMemberItem
